module.exports = __webpack_public_path__ + "media/images/icon__checkmark-d5de29699b0c37c3445c21e448ec16a7.png";